import I18n from "./i18n.js";
let i18n;

(async () => {
    const locale = window.location.search.split("=")[1] || "de";
    const i18nInstance = await I18n.create({
        path: "/locales",
        language: locale,
        extension: ".json",
    });
    i18n = i18nInstance;
})();

export { i18n };